export default "__VITE_ASSET__BiIwC2Vr__"